import React, { useState } from 'react'
import TabPanel from '../tabPanel/TabPanel'
import {customStyle, overrideStyle} from './TabMenuStyle'
import {properties} from './TabMenuData';
import {Grid, AppBar, Tabs, Tab, ThemeProvider} from '@material-ui/core';

export default function TabMenu(props) {

    const [selectedSectionIndex, setSelectedSectionIndex] = useState(false);
    const style = customStyle();

    const handleChange = (event, newValue) => {
        if(newValue === selectedSectionIndex){
            closePanel();
        }else{
            setSelectedSectionIndex(newValue);
        }
    };

    const closePanel = () => {
        setSelectedSectionIndex(false);
    }

    const renderTabs = () => {

        return ( 
            props.data.map((tab) =>{
            return(
                <Tab disableRipple tabIndex='0' title={tab.tituloSeccion} className={style.tab} label={tab.tituloSeccion} icon={<img className={style.classIcon} src={properties.MEDIA_PATH + tab.imagen}/>}/>
            )
            })
        )
    }

    const renderTabsPanels = () => {
        return ( props.data.map((tab, index) =>{
            return (
                <TabPanel tabData={tab} selectedSectionIndex={selectedSectionIndex} index={index} close={closePanel}/>
            )
        }))
    }

    return (
        <Grid container className={style.gridMenu} alignItems='center'>
            <ThemeProvider theme={overrideStyle}>
                <AppBar className={style.appBar} position='static'>
                    <Tabs className={style.tabs}
                    value={selectedSectionIndex}
                    onChange={handleChange}
                    role='menu'
                    >
                    {renderTabs()}
                    </Tabs>
                </AppBar>
                {renderTabsPanels()}
            </ThemeProvider>
        </Grid>
    )
}